import { useEffect, useState } from 'react';

export const CompleteProfileModal = ({ isOpen, onClose, onComplete, progress = 75, playerName = 'Player' }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Trigger animation after modal is mounted
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    setShowModal(false);
    setTimeout(onClose, 300); // Wait for animation to complete
  };

  const handleCompleteProfile = () => {
    setShowModal(false);
    setTimeout(() => {
      onClose();
      if (onComplete) {
        onComplete();
      }
    }, 300); // Wait for animation to complete
  };

  const ringRadius = 52;
  const ringLength = 2 * Math.PI * ringRadius;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${
          showModal ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={handleClose}
      />

      {/* Modal */}
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="complete-profile-title"
        className={`relative w-full max-w-2xl bg-jp-card rounded-2xl border border-jp-outline/70 shadow-2xl p-6 sm:p-10 text-center transition-all duration-300 ${
          showModal ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        <button
          type="button"
          onClick={handleClose}
          aria-label="Close"
          className="absolute top-4 right-4 p-1 rounded-lg text-jp-muted hover:text-jp-ink hover:bg-jp-section transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Welcome Section */}
        <p className="text-jp-accent dark:text-jp-gold text-sm font-bold uppercase tracking-widest mb-3">
          Welcome Back
        </p>
        <h2 id="complete-profile-title" className="text-4xl sm:text-5xl font-anton leading-[1.1] tracking-tight text-jp-ink">
          {playerName.toUpperCase()} <span aria-hidden="true">👋</span>
        </h2>
        <p className="mt-3 text-jp-muted text-base sm:text-lg">You're one step closer to your baseball dream.</p>

        {/* Progress Section */}
        <div className="my-8 rounded-xl p-6 sm:p-8 bg-jp-section border border-jp-outline/50">
          <div className="relative w-32 h-32 mx-auto mb-5">
            <svg className="w-full h-full -rotate-90" viewBox="0 0 120 120" aria-hidden="true">
              <circle cx="60" cy="60" r={ringRadius} stroke="currentColor" strokeWidth="10" fill="none" className="text-jp-line" />
              <circle
                cx="60"
                cy="60"
                r={ringRadius}
                stroke="currentColor"
                strokeWidth="10"
                fill="none"
                strokeDasharray={ringLength}
                strokeDashoffset={ringLength * (1 - progress / 100)}
                strokeLinecap="round"
                className="text-jp-accent"
              />
            </svg>
            <span className="absolute inset-0 flex items-center justify-center text-3xl font-extrabold text-jp-ink tabular-nums">
              {progress}%
            </span>
          </div>
          <p className="text-jp-ink font-bold text-lg uppercase tracking-wide mb-3">Your profile is {progress}% complete</p>
          <p className="text-jp-muted text-sm sm:text-base leading-relaxed">
            Upload a <span className="font-semibold text-jp-ink">highlight video</span>, a <span className="font-semibold text-jp-ink">coach recommendation</span>, and <span className="font-semibold text-jp-ink">share your awards</span> — this will complete your profile 100% and significantly boost your chances of getting noticed by coaches.
          </p>
        </div>

        {/* Complete Button */}
        <button
          type="button"
          onClick={handleCompleteProfile}
          className="w-full sm:w-auto sm:px-12 py-4 text-base font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-600 text-slate-900 rounded-xl hover:brightness-110 transition-all shadow-lg shadow-cyan-500/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jp-card active:scale-[0.98]"
        >
          Complete My Profile
        </button>
      </div>
    </div>
  );
};

export default CompleteProfileModal;






// import { useEffect, useState } from 'react';

// export const CompleteProfileModal = ({ isOpen, onClose, onComplete, progress = 75 }) => {
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     if (isOpen) {
//       // Trigger animation after modal is mounted
//       setTimeout(() => setShowModal(true), 10);
//     } else {
//       setShowModal(false);
//     }
//   }, [isOpen]);

//   if (!isOpen) return null;

//   const handleClose = () => {
//     setShowModal(false);
//     setTimeout(onClose, 300); // Wait for animation to complete
//   };

//   const handleCompleteProfile = () => {
//     setShowModal(false);
//     setTimeout(() => {
//       onClose();
//       if (onComplete) {
//         onComplete();
//       }
//     }, 300); // Wait for animation to complete
//   };

//   return (
//     <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
//       {/* Backdrop */}
//       <div
//         className={`absolute inset-0 bg-black/70 backdrop-blur-sm transition-opacity duration-300 ${
//           showModal ? 'opacity-100' : 'opacity-0'
//         }`}
//         onClick={handleClose}
//       />

//       {/* Modal */}
//       <div className={`relative bg-gradient-to-br from-slate-800 via-slate-900 to-slate-950 rounded-3xl p-8 sm:p-12 max-w-3xl w-full shadow-2xl border border-slate-700/50 transition-all duration-300 ${
//         showModal ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
//       }`}>
        
//         {/* Welcome Section */}
//         <div className="text-center mb-8">
//           <div className="flex items-center justify-center gap-3 mb-4">
//             <h2 className="text-3xl sm:text-4xl font-extrabold text-white">WELCOME BACK, ALEX!</h2>
//             <span className="text-3xl sm:text-4xl">👋</span>
//           </div>
//           <p className="text-white text-lg">You're one step closer to your baseball dream</p>
//         </div>

//         {/* Progress Section */}
//         <div className="text-center mb-8">
//           <p className="text-white font-bold text-xl mb-6">YOUR PROFILE IS {progress}% COMPLETE</p>
          
//           {/* Baseball Icon with Progress */}
//           <div className="relative inline-block mb-8">
//             {/* Baseball Icon Circle - Rotated 20 degrees */}
//             <div className="text-[12rem] transform rotate-[25deg]">⚾</div>

//             {/* Progress Text in Center */}
//             <div className="absolute inset-0 flex items-center justify-center">
//               <span className="text-4xl font-bold text-slate-900">{progress}%</span>
//             </div>
//           </div>

//           {/* Instructions */}
//           <div className="text-white text-base leading-relaxed mb-8">
//             <p>
//               Upload a <span className="font-bold">highlight video</span>, a <span className="font-bold">coach recommendation</span>, and <span className="font-bold">share your awards</span> — this will complete your profile 100% and significantly boost your chances of getting noticed by coaches.
//             </p>
//           </div>

//           {/* Complete Button */}
//           <button
//             onClick={handleCompleteProfile}
//             className="px-8 py-3 bg-white hover:bg-gray-100 text-slate-900 rounded-xl font-bold text-lg uppercase tracking-wide transition-all shadow-lg hover:shadow-xl"
//           >
//             COMPLETE MY PROFILE
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CompleteProfileModal;
